module.exports = __webpack_public_path__ + "img/oneGreen.e7afab73.jpg";